import { Loader2, type LucideIcon } from 'lucide-react';
import { Button } from './ui/button';
import { cn } from 'lib/utils';

interface ReportActionButtonProps {
  text: string;
  icon: LucideIcon;
  onClick?: () => void;
  className?: string;
  isLoading?: boolean;
  disabled?: boolean;
}

export default function ReportActionButton({
  onClick,
  text,
  icon: Icon,
  className,
  isLoading = false,
  disabled = false,
}: ReportActionButtonProps) {
  return (
    <Button
      variant='outline'
      className={cn(
        'h-8 px-4 rounded-lg text-secondary border-secondary sm:rounded-full hover:bg-secondary/10 hover:text-secondary transition-all duration-200',
        className
      )}
      onClick={() => onClick?.()}
      disabled={isLoading || disabled}
    >
      {isLoading ? (
        <Loader2 className='sm:mr-2 size-4 animate-spin' data-testid='loader' />
      ) : (
        <Icon className='w-4 h-4 sm:mr-2' data-testid='icon' />
      )}
      <span className='hidden sm:inline-block'>{text}</span>
    </Button>
  );
}
